<template>
  <div class="DarkWhite pa-4">
      <h2 class="subheading green--text">Delivery Unit</h2>

      <v-card class="mt-4">
      <BudgetDeliveryUnit/>
  </v-card>
  </div>
</template>

<script>
import BudgetDeliveryUnit from '@/components/Utils/BudgetDeliveryUnit.vue'
  export default {
    components: {
      BudgetDeliveryUnit
    },
    data: () => ({
    }),
  }
</script>

<style scoped>
</style>